import { createIcon } from '@chakra-ui/react'

export const LinkedinAvatarFallback = createIcon({
  displayName: 'LinkedinAvatarFallback',
  viewBox: '0 0 40 40',
  path: (
    <g clipPath="url(#clip0_521_131)">
      <path d="M0 0H40V40H0V0Z" fill="#7A7A7A" />
      <path
        d="M27.6281 26.4603C28.8618 25.005 29.6533 23.2272 29.9095 21.3367C30.1656 19.4461 29.8756 17.5218 29.0736 15.7907C28.2717 14.0596 26.9913 12.594 25.3836 11.567C23.7758 10.5399 21.9078 9.99414 20 9.99414C18.0922 9.99414 16.2242 10.5399 14.6164 11.567C13.0087 12.594 11.7283 14.0596 10.9264 15.7907C10.1244 17.5218 9.83441 19.4461 10.0905 21.3367C10.3467 23.2272 11.1383 25.005 12.3719 26.4603C17.2712 24.5145 22.7289 24.5145 27.6281 26.4603Z"
        fill="white"
      />
      <path
        d="M27.6281 26.459C26.6894 27.5664 25.5207 28.4562 24.2035 29.0664C22.8862 29.6767 21.4518 29.9928 20 29.9928C18.5482 29.9928 17.1138 29.6767 15.7965 29.0664C14.4793 28.4562 13.3106 27.5664 12.3719 26.459C9.41474 27.6249 6.76297 29.4508 4.61887 31.7975C2.47476 34.1441 0.894966 36.9495 0 39.9996H40C39.105 36.9495 37.5252 34.1441 35.3811 31.7975C33.237 29.4508 30.5853 27.6249 27.6281 26.459Z"
        fill="#D9D9D9"
      />
      <path
        d="M20.0002 30C21.4528 30.0006 22.8879 29.6841 24.2055 29.0726C25.523 28.461 26.6912 27.5692 27.6283 26.4594C22.729 24.5135 17.2714 24.5135 12.3721 26.4594C13.3092 27.5692 14.4773 28.461 15.7949 29.0726C17.1125 29.6841 18.5476 30.0006 20.0002 30Z"
        fill="#F1F1F1"
      />
      <clipPath id="clip0_521_131">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </g>
  ),
})
